import { Component } from 'react';
import { stringify } from 'query-string';

class PageWithFilters extends Component {
  getMyAppsIds = (filters, userApps, isAuth) => {
    if (!isAuth || !filters) {
      return [];
    }

    const appIds = [];

    userApps.forEach(app => {
      if (app.plans.length) {
        app.plans.forEach(plan => appIds.push(plan.app_plan_id));
      } else {
        appIds.push(app.id);
      }
    });

    const appIdsWithContent = this.getAppsIdsWithContent(appIds, filters);

    return appIdsWithContent;
  };

  getFreeAppsIds = filters => {
    if (!filters) {
      return [];
    }

    const appIds = filters.apps.filter(app => !app.price).map(app => app.id);

    return appIds;
  };

  getAppsIdsWithContent = (appIds, filters) => {
    return appIds.filter(app_id => filters.apps.find(app => app.id === app_id));
  };

  getLinkWithQueryParams = (route, params = {}) => {
    const search = stringify(params, {
      arrayFormat: 'comma',
      skipEmptyString: true,
    });

    const linkWithParams = `${route}?${search}`;

    return linkWithParams;
  };
}

export default PageWithFilters;
